var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTuneSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,18L3,18c0,0.55,0.45,1,1,1h5v-2H4C3.45,17,3,17.45,3,18z M3,6L3,6c0,0.55,0.45,1,1,1h9V5H4C3.45,5,3,5.45,3,6z M13,20 v-1h7c0.55,0,1-0.45,1-1l0,0c0-0.55-0.45-1-1-1h-7v-1c0-0.55-0.45-1-1-1l0,0c-0.55,0-1,0.45-1,1v4c0,0.55,0.45,1,1,1l0,0 C12.55,21,13,20.55,13,20z M7,10v1H4c-0.55,0-1,0.45-1,1l0,0c0,0.55,0.45,1,1,1h3v1c0,0.55,0.45,1,1,1l0,0c0.55,0,1-0.45,1-1v-4 c0-0.55-0.45-1-1-1l0,0C7.45,9,7,9.45,7,10z M21,12L21,12c0-0.55-0.45-1-1-1h-9v2h9C20.55,13,21,12.55,21,12z M16,9L16,9 c0.55,0,1-0.45,1-1V7h3c0.55,0,1-0.45,1-1l0,0c0-0.55-0.45-1-1-1h-3V4c0-0.55-0.45-1-1-1l0,0c-0.55,0-1,0.45-1,1v4 C15,8.55,15.45,9,16,9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuneSvg);
export default __webpack_public_path__ + "static/media/TuneSvg.55c12ac30d1a00ae2bbdc14550ab1fa0.svg";
export { ForwardRef as ReactComponent };